import React, { useContext, useState } from 'react';
import { Button, styled } from '@nextiva/next-ui-components';
import { getSmartTemplate } from 'services';
import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { getTitleFromHeader } from './utils';

interface Props {
  title: string;
}
const StyledDownloadButton = styled(Button)`
  &.MuiButton-root {
    padding: 12px 32px;
    line-height: 1rem;
  }
`;

const TITLES = {
  LOCATIONS: 'Locations',
  USERS: 'Users',
  TEAMS: 'Teams',
  PHONES_AND_DEVICES: 'Phones & Devices',
  USER_UPDATE: 'Edit user',
};

const downloadText = {
  [TITLES.USERS]: 'Download new users template',
  [TITLES.TEAMS]: 'Download new teams template',
  [TITLES.LOCATIONS]: 'Download new locations template',
  [TITLES.PHONES_AND_DEVICES]: 'Download new devices template',
  [TITLES.USER_UPDATE]: 'Download edit users template',
};

const getEntityType = {
  [TITLES.USERS]: 'USER',
  [TITLES.TEAMS]: 'TEAM',
  [TITLES.LOCATIONS]: 'LOCATION',
  [TITLES.PHONES_AND_DEVICES]: 'DEVICE',
  [TITLES.USER_UPDATE]: 'USER_UPDATE',
};

export const DownloadTemplate = ({ title }: Props) => {
  const { corpAcctNbr } = useContext(FeatureContext);
  const [blocked, setBlocked] = useState(false);
  const downloadSmartTemplate = async () => {
    setBlocked(true);
    const { data: octetStreamData, headers } = await getSmartTemplate(
      getEntityType[title],
      corpAcctNbr,
    );
    const name = getTitleFromHeader(headers['content-disposition']);
    setBlocked(false);
    const xlsxDownloadLink = document.createElement('a');
    xlsxDownloadLink.href = URL.createObjectURL(octetStreamData);
    xlsxDownloadLink.download = name;
    xlsxDownloadLink.click();
  };

  return (
    <StyledDownloadButton
      color="primary"
      size="medium"
      variant="outlined"
      onClick={downloadSmartTemplate}
      disabled={blocked}
      data-testid={`PlatformAdminUI-DataDownloadTemplate-Download-${title.replace(
        /\s+/g,
        '-',
      )}`}
    >
      {downloadText[title]}
    </StyledDownloadButton>
  );
};
